var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"message",class:_vm.type},[_c('div',{staticClass:"message-body"},[_c('div',{staticClass:"icon-text"},[_c('b-icon',{attrs:{"type":_vm.type,"size":_vm.size,"icon":_vm.icon}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }